"use strict";

let inputs = document.querySelectorAll(".input");

function focusFunc() {
    let t = this.parentNode.parentNode;
    t.classList.add("focus");
}

function blurFunc() {
    let t = this.parentNode.parentNode;
    "" == this.value && t.classList.remove("focus");
}

inputs.forEach(function(t) {
    t.addEventListener("focus", focusFunc),
        t.addEventListener("change", focusFunc),
            t.addEventListener("blur", blurFunc);
});

$(function() {
    $(".extra-btn").on("click", function() {
        $(this).addClass("active-btn");
    });
});
